<template>
  <div class="pubdataset">
    <a-row :gutter="[12, 24]">
      <a-col
        :xs="{ span: 0 }"
        :sm="{ span: 0 }"
        :md="{ span: 0 }"
        :xl="{ span: 6 }"
        :lg="{ span: 6 }"
      >
        <a-affix :offset-top="100">
          <a-card size="small" title="Table of contents">
            <a
              @click="changeHash('#basic')"
              type="primary"
              style="margin-top: 20px; font-size: 17px"
              >1. Basic information
            </a>
            <br />
            <a
              @click="changeHash('#rank')"
              style="margin-top: 20px; font-size: 17px"
              type="primary"
              >2. Perturbation rate
            </a>
            <br />
            <a
              @click="changeHash('#umap')"
              style="margin-top: 20px; font-size: 17px"
              type="primary"
              >3.
              <!-- <a-icon type="fire" theme="twoTone" two-tone-color="#eb2f96" /> -->
              Perturbation analysis</a
            >
            <br />
            <a
              @click="changeHash('#regular')"
              style="margin-top: 20px; font-size: 17px"
              type="primary"
              >4.
              <!-- <a-icon type="fire" theme="twoTone" two-tone-color="#eb2f96" /> -->
              UMAP for dimensionality reduction</a
            >
            <br />
            <a
              @click="changeHash('#cor')"
              style="margin-top: 20px; font-size: 17px"
              type="primary"
              >5.
              <!-- <a-icon type="fire" theme="twoTone" two-tone-color="#eb2f96" /> -->
              Perturbation transcriptome similarity</a
            >
            <br v-if="this.marker != 0" />
            <a
              v-if="this.marker != 0"
              @click="changeHash('#pc')"
              style="margin-top: 20px; font-size: 17px"
              type="primary"
              >6. Perturbation cluster</a
            >
            <br />
            <a
              @click="changeHash('#vnplotAnchor')"
              style="margin-top: 20px; font-size: 17px"
              type="primary"
            >
              <span v-if="this.marker != 0">7.</span>
              <span v-else> 6.</span>
              Upstream regulator</a
            >
          </a-card>
        </a-affix>
      </a-col>
      <a-col
        :sm="{ span: 24 }"
        :md="{ span: 24 }"
        :xl="{ span: 18 }"
        :gutter="[16, 24]"
      >
        <a-row>
          <a-col :sm="{ span: 24 }" :md="{ span: 24 }" :xl="{ span: 24 }">
            <a-card
              size="small"
              id="basic"
              style="border-radius: 5px; border-color: #c9c9c9"
              hoverable
              :headStyle="{ backgroundColor: '#E0E0E0', borderRadius: '5px' }"
            >
              <a
                slot="title"
                style="font-size: 20px; color: black"
                class="guider"
              >
                Dataset Information
              </a>
              <a-descriptions bordered size="small">
                <a-descriptions-item label="Dataset ID">
                  <i style="font-weight: bolder; color: black">
                    {{ this.$route.query.datasetId }}</i
                  >
                </a-descriptions-item>
                <a-descriptions-item label="Cell line">
                  {{ this.cell }}
                </a-descriptions-item>
                <a-descriptions-item label="Sample type">
                  {{ this.sample }}
                </a-descriptions-item>
                <a-descriptions-item label="Title">
                  <span class="title">{{ this.title }}</span>
                </a-descriptions-item>
                <a-descriptions-item label="Publication">
                  <template v-if="periodicals.startsWith('Publicly')">
                    <a-tooltip title="The article is not yet published.">
                      {{ periodicals }}
                    </a-tooltip>
                  </template>
                  <template v-else>
                    {{ periodicals }}
                  </template>
                </a-descriptions-item>

                <a-descriptions-item label="Year">
                  {{ this.time }}
                </a-descriptions-item>

                <a-descriptions-item label="Description">
                  <div style="text-align: justify">
                    {{ this.summary }}
                  </div>
                </a-descriptions-item>
              </a-descriptions>
            </a-card>
          </a-col>
          <a-col
            :sm="{ span: 24 }"
            :md="{ span: 24 }"
            :xl="{ span: 24 }"
            style="margin-top: 10px"
          >
            <a-card
              size="small"
              id="rank"
              style="
                margin-top: 10px;
                border-radius: 5px;
                border-color: #c9c9c9;
              "
              hoverable
              :headStyle="{ backgroundColor: '#E0E0E0', borderRadius: '5px' }"
            >
              <a slot="title" class="guider" style="color: black"
                >Perturbation Rate</a
              >
              <a-card style="width: 100%">
                <efficiency :efficiency="efficiency"
              /></a-card>
              <!-- 
              <a-row :gutter="[8, 24]" style="margin-top: 5px">
                <a-col :sm="{ span: 12 }" :md="{ span: 12 }" :xl="{ span: 12 }">
                  <umap />
                </a-col>
                <a-col :sm="{ span: 12 }" :md="{ span: 12 }" :xl="{ span: 12 }">
                  <a-card style="width: 100%"> <freqTableVue /></a-card
                ></a-col>
              </a-row> -->
            </a-card>
          </a-col>
          <a-col
            :sm="{ span: 24 }"
            :md="{ span: 24 }"
            :xl="{ span: 24 }"
            style="margin-top: 10px"
          >
            <a-card
              size="small"
              id="umap"
              style="
                margin-top: 10px;
                border-radius: 5px;
                border-color: #c9c9c9;
              "
              hoverable
              :headStyle="{ backgroundColor: '#E0E0E0', borderRadius: '5px' }"
            >
              <a slot="title" class="guider" style="color: black"
                >Perturbation Analysis by Mixscape</a
              >
              <!-- <a-card style="width: 100%">
                <efficiency :efficiency="efficiency"
              /></a-card> -->

              <a-row :gutter="[8, 24]" style="margin-top: 5px">
                <a-col :sm="{ span: 12 }" :md="{ span: 12 }" :xl="{ span: 12 }">
                  <umap
                    v-if="
                      !['SC00002', 'SC00003', 'SC00004'].includes(
                        $route.query.datasetId
                      )
                    "
                  />
                  <umappc v-else />
                </a-col>
                <a-col :sm="{ span: 12 }" :md="{ span: 12 }" :xl="{ span: 12 }">
                  <a-card style="width: 100%"> <freqTableVue /></a-card
                ></a-col>
              </a-row>
            </a-card>
          </a-col>
          <a-col
            :sm="{ span: 24 }"
            :md="{ span: 24 }"
            :xl="{ span: 24 }"
            style="margin-top: 10px"
            id="regular"
          >
            <a-card
              size="small"
              style="
                margin-top: 10px;
                border-radius: 5px;
                border-color: #c9c9c9;
              "
              hoverable
              :headStyle="{ backgroundColor: '#E0E0E0', borderRadius: '5px' }"
            >
              <a slot="title" class="guider" style="color: black"
                >UMAP for Dimensionality Reduction by SNN Algorithm</a
              >
              <a-row
                v-if="
                  [
                    'SC00002',
                    'SC00004',
                    'SC00003',
                    'SC00065',
                    'SC00066',
                  ].includes($route.query.datasetId)
                "
              >
                <a-col :span="24"> <regularUmap /></a-col>
              </a-row>

              <a-row v-else>
                <a-col :span="12"> <regularUmap /></a-col>
                <a-col :span="12"> <regularUmapGene /></a-col>
              </a-row>
            </a-card>
          </a-col>
          <a-col
            :sm="{ span: 24 }"
            :md="{ span: 24 }"
            :xl="{ span: 24 }"
            style="margin-top: 10px"
            id="cor"
          >
            <a-card
              size="small"
              style="
                margin-top: 10px;
                border-radius: 5px;
                border-color: #c9c9c9;
              "
              hoverable
              :headStyle="{ backgroundColor: '#E0E0E0', borderRadius: '5px' }"
            >
              <a slot="title" class="guider" style="color: black"
                >Perturbed Transcriptome Similarity</a
              >
              <a-row>
                <a-col :span="24"> <corNet /> </a-col>
              </a-row>
            </a-card>
          </a-col>

          <a-col
            :sm="{ span: 24 }"
            :md="{ span: 24 }"
            :xl="{ span: 24 }"
            style="margin-top: 10px"
            id="pc"
            v-if="this.marker != 0"
          >
            <a-card
              size="small"
              style="
                margin-top: 10px;
                border-radius: 5px;
                border-color: #c9c9c9;
              "
              hoverable
              :headStyle="{ backgroundColor: '#E0E0E0', borderRadius: '5px' }"
            >
              <a slot="title" class="guider" style="color: black"
                >Perturbation Cluster</a
              >
              <pc />
            </a-card>
          </a-col>
          <a-col
            :sm="{ span: 24 }"
            :md="{ span: 24 }"
            :xl="{ span: 24 }"
            style="margin-top: 10px"
            id="vnplotAnchor"
          >
            <a-card
              size="small"
              style="
                margin-top: 10px;
                border-radius: 5px;
                border-color: #c9c9c9;
              "
              :headStyle="{ backgroundColor: '#E0E0E0', borderRadius: '5px' }"
              hoverable
            >
              <a slot="title" class="guider" style="color: black">
                Upstream Regulator
              </a>
              <a-row :gutter="[8, 24]">
                <h3 style="margin-top: 10px"></h3>
                <detable />
              </a-row>
            </a-card>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
  </div>
</template>
<script>
import efficiency from "./efficiency.vue";
import umap from "./umap.vue";
import umappc from "./umap_pcV.vue";
import regularUmap from "./umap_regular.vue";
import regularUmapGene from "./umap_regularGene.vue";
import corNet from "./corNet.vue";
import pc from "./clusterTable.vue";
// import wiki from "./pathway_wiki.vue";
// import kegg from "./pathway_kegg.vue";
// import reactome from "./pathway_reactome.vue";
import freqTableVue from "./freqTable.vue";
import axios from "axios";
import detable from "./de_table.vue";
// import { Sketch } from "vue-color";
// import corheatmap from "./corheatmap.vue";
// import pdf from "vue-pdf";
export default {
  components: {
    efficiency,
    umap,
    umappc,
    regularUmap,
    regularUmapGene,
    corNet,
    pc,

    // corTable,
    // wiki,
    // kegg,
    // reactome,
    freqTableVue,
    detable,
    // "sketch-picker": Sketch,
    // corheatmap,
  },
  mounted() {
    axios
      .get(
        "http://research.gzsys.org.cn/perturbdb/API/clusters/clusters_all.php"
      )
      .then((response) => {
        // this.getdata_detable = response.data;
        var pcdata = response.data.filter(
          (item) => item.datasetID === this.$route.query.datasetId
        );
        if (Array.isArray(pcdata) && pcdata.length > 0) {
          this.marker = 1;
        }
      });
    axios
      .get(
        "http://research.gzsys.org.cn/perturbdb/API/publications_basic.php",
        {
          params: { datasetid: this.$route.query.datasetId },
        }
      )
      .then((response) => {
        this.title = response.data[0]["title"];
        this.periodicals = response.data[0]["periodicals"];
        this.time = response.data[0]["time"];
        this.cell = response.data[0]["cell"];
        this.sample = response.data[0]["sample"];
        this.num = response.data[0]["num"];
        this.summary = response.data[0]["summary"];
        this.clusters = response.data[0]["clusters"];
        // if (response.data[0]["umap"] == "False") {
        //   this.showUmap = false;
        //   this.tablespan = 24;
        // }
        //console.log(response.data[0]["umap"]);
        //this.genelist = response.data[0]["customeGenes"]["xaxis"];
        // this.yaxis = response.data[0]["customeGenes"]["yaxis"];
      });
  },
  data() {
    return {
      //show
      marker: 0,
      showUmap: true,
      umpaspan: 10,
      tablespan: 14,
      title: null,
      periodicals: null,
      time: null,
      cell: null,
      sample: null,
      num: null,
      summary: null,
      clusters: 0,
      value: ["NT"],
      chooseGene: "",
      visible: false,
      //genelist:
      genelist: null,
      yaxis:
        "http://research.gzsys.org.cn/perturbdb/data/publications/" +
        this.$route.query.datasetId +
        "/customeGene.txt",
      //vnplot
      vnplotlinks: null,
      vnplot_visible: true,
      //color #不得行
      color: "#FF0000",
      isShowColors: false,
      color2: "#0000FF",
      isShowColors2: false,
      //other params
      doLog: 0,
      doNP: 0,
      //corMatrix
      corMatrix:
        "http://research.gzsys.org.cn/perturbdb/data/publications/" +
        this.$route.query.datasetId +
        "/corMatrix.txt",
    };
  },
  watch: {
    value(val) {
      console.log(`selected:`, val);
    },
    // chooseGene(val) {
    //   console.log(`selected:`, val);
    //   if (this.chooseGene.length > 1) {
    //     this.$message.warning(
    //       "Please choose one gene! This will disappear in 3 seconds.",
    //       3
    //     );
    //     this.chooseGene = [];
    //   }
    // },
  },
  methods: {
    gotoSeurat() {
      let href = "https://satijalab.org/seurat/reference/averageexpression";

      window.open(href, "_blank");
    },
    // 颜色输入框点击事件处理1
    colorInputClick() {
      this.isShowColors = !this.isShowColors;
    },
    colorInputOut() {
      this.isShowColors = !this.isShowColors;
    },
    // 颜色值改变事件处理
    colorValueChange(val) {
      console.log(val);

      // 取颜色对象的十六进制值
      this.color = val.hex;
    },
    // 颜色输入框点击事件处理2
    colorInputClick2() {
      this.isShowColors2 = !this.isShowColors2;
    },
    colorInputOut2() {
      this.isShowColors2 = !this.isShowColors2;
    },
    // 颜色值改变事件处理
    colorValueChange2(val) {
      console.log(val);

      // 取颜色对象的十六进制值
      this.color2 = val.hex;
    },
    //改变other option
    changeLog(e) {
      //this.$message.success(e.target.value);
      console.log(e.target.value);
    },
    changeNP(e) {
      //this.$message.success(e.target.value);
      console.log(e.target.value);
    },
    vnplot() {
      this.visible = true;
      this.vnplot_visible = true;
      this.vnplotlinks = null;
      // console.log(this.$route.query.datasetId);
      // console.log(String(this.value));
      // console.log(String(this.chooseGene));
      ///console.log(String(this.color).split("#")[1]);
      //console.log(String(this.color2).split("#")[1]);
      // console.log(String(this.doLog));
      // console.log(String(this.doNP));
      axios
        .get("http://research.gzsys.org.cn/perturbdb/API/plot/01vnplot.php", {
          params: {
            datasetId: this.$route.query.datasetId,
            value: String(this.value),
            choosegene: String(this.chooseGene),
            color1: String(this.color).split("#")[1],
            color2: String(this.color2).split("#")[1],
            dolog: this.doLog,
            doNP: this.doNP,
          },
        })
        .then((response) => {
          if (response.data != "failed") {
            this.vnplot_visible = false;
            this.$message.success(response.data + ".pdf plotted!", 6);
            this.vnplotlinks =
              "http://research.gzsys.org.cn/perturbdb/data/temppPlot/" +
              response.data +
              ".pdf#zoom=60";
          } else {
            this.visible = false;
            this.vnplot_visible = false;
            this.vnplotlinks = null;
            this.$message.error(
              "Please check step2, and input an valid gene!",
              6
            );
          }
        });
    },
    changeHash(idname) {
      document.querySelector(idname).scrollIntoView({
        behavior: "smooth",
        // block: "start",
        // inline: "nearest",
      });
    },
  },
};
</script>
<style scpoed>
.h1 {
  font-size: 40px;
  font-weight: bolder;
}
.title {
  font-weight: bolder;
  color: black;
}
.guider {
  font-weight: bolder;
  font-size: 20px;
}
</style>
